<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block"> {{heading}}</div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <div class="body" style="padding: 16px 24px 16px 24px;">
        <div class="row">
            <div class="col-md-6" style="padding-left: 16px !important; padding-right: 10px !important;">
                <div>
                    <label class="catlabel"> Date Of Trigger:</label>
                    <input type="text" class="content" [(ngModel)]="dateOfTrigger" disabled=true>
                </div>
                <div>
                    <label class="catlabel">Domicile:</label>
                    <input type="text" class="content" [(ngModel)]="domicile" disabled=true>
                </div>
                <div>
                    <label class="catlabel">Responsible User:</label>
                    <span class="content">
                        <mat-form-field appearance="outline" style="width: 100%;" class="fixed-select">
                            <mat-select [(ngModel)]="resUser" placeholder="Select">
                                <mat-option>
                                    <ngx-mat-select-search [formControl]="resUserFilterCtrl" placeholderLabel="Search"
                                        noEntriesFoundLabel="No results found">
                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let option of filteredResUsers | async" [value]="option">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </span>
                </div>
                <div>
                    <label class="catlabel">Planned Blowout:</label>
                    <span class="content">
                        <select class="category" [(ngModel)]="plannedBlowout" (change)="callingRootCause()"
                            [style.width]="'78px'">
                            <option *ngFor="let option of yesNoDropDown" [value]="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                    </span>
                </div>
                <div>
                    <label class="catlabel">Plan Maxload Target Date:</label>
                    <input type="text" class="content" [(ngModel)]="planMaxloadTargetDate" disabled=true>
                </div>
                <div>
                    <label class="catlabel">OWK Maxload Target
                        Date:</label>
                    <input type="text" class="content" [(ngModel)]="oWKMaxloadTargetDate" disabled=true>
                </div>
                <div>
                    <label class="catlabel">Actual Investigation Complete:</label>
                    <span class="content">
                        <input type="date" class="category" style="width: 111px;"
                            [(ngModel)]="actualInvestigationComplete">
                    </span>
                </div>
                <div>
                    <label class="catlabel">Root Cause:</label>
                    <span class="content">
                        <mat-form-field appearance="outline" style="width: 100%;" class="fixed-select">
                            <mat-select [(ngModel)]="rootCause"
                                [disabled]="!(plannedBlowout == 1 || plannedBlowout == 0) || !(owkBlowouts == 1 || owkBlowouts == 0)"
                                placeholder="Select">
                                <mat-option>
                                    <ngx-mat-select-search [formControl]="rootCauseFilterCtrl" placeholderLabel="Search"
                                        noEntriesFoundLabel="No results found">
                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let option of filteredRootCauses | async" [value]="option">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </span>
                </div>
            </div>
            <div class="col-md-6" style="padding-left: 10px !important; padding-right: 16px !important;">
                <div>
                    <label class="catlabel">Load Number:</label>
                    <input type="text" class="content" [(ngModel)]="loadNumber" disabled=true>
                </div>
                <div>
                    <label class="catlabel">Route:</label>
                    <input type="text" class="content" [(ngModel)]="route" disabled=true>
                </div>
                <div>
                    <label class="catlabel">Blowouts:</label>
                    <input type="text" class="content" [(ngModel)]="blowouts" disabled=true>
                </div>
                <div>
                    <label class="catlabel">OWK Blowout:</label>
                    <span class="content">
                        <select class="category" [(ngModel)]="owkBlowouts" (change)="callingRootCause()"
                            [style.width]="'78px'">
                            <option *ngFor="let option of yesNoDropDown" [value]="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                    </span>
                </div>
                <div>
                    <label class="catlabel">Plan Maxload Actual Date:</label>
                    <span class="content">
                        <input type="date" class="category" style="width: 111px;" [(ngModel)]="planMaxloadActualDate">
                    </span>
                </div>
                <div>
                    <label class="catlabel">OWK Maxload Actual Date:</label>
                    <span class="content">
                        <input type="date" class="category" style="width: 111px;" [(ngModel)]="owkMaxloadActualDate">
                    </span>
                </div>
                <div>
                    <label class="catlabel">Actual Countermeasure
                        Complete:</label>
                    <span class="content">
                        <input type="date" class="category" style="width: 111px;"
                            [(ngModel)]="actualCountermeasureComplete">
                    </span>
                </div>
                <div>
                    <label class="catlabel">Countermeasure:</label>
                    <span class="content">
                        <mat-form-field appearance="outline" class="fixed-select">
                            <mat-select [(ngModel)]="countermeasure"
                                [disabled]="!(plannedBlowout === 1 || plannedBlowout === 0) || !(owkBlowouts === 1 || owkBlowouts === 0)"
                                placeholder="Select">
                                <mat-option>
                                    <ngx-mat-select-search [formControl]="countermeasureFilterCtrl"
                                        placeholderLabel="Search" noEntriesFoundLabel="No results found">
                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let item of filteredCountermeasures | async" [value]="item">
                                    {{ item.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
    <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
        <button (click)="onNoClick()" class="mCancel"> CANCEL</button>
        <button mat-raised-button class="black-btn" style="display: inline;" (click)="saveClick()">SAVE</button>
    </div>
</div>